import request from '@/utils/request';

/**
 * 获取全局配置
 **/
export const getGlobalConfig = (params = {}) => {
    return request({
        url: 'https://api.zhgylgl.com/api/common/getConfig',
        method: 'get',
        params
    })
}

/**
 * 获取全局配置
 * 经纬度转地址逆地理
 **/
export const reverseGeocoding = (params = {}) => {
    return request({
        url: 'https://api.zhgylgl.com/api/common/reverseGeocoding',
        method: 'get',
        params
    })
}